import React from 'react';
import { Typography, Grid } from '@mui/material';
import { ID_SITE } from '@shared/conf/env';

import { sxStyle } from '../../styles';

const EntityInfo = ({ bookingDetails, getHref, hasEntity }) => {
  const ID_SITE_CONST = Number(ID_SITE);

  return (
    <>
      {hasEntity && ID_SITE_CONST !== 2 && (
        <Grid
          item
          xs={12}
          sx={{
            padding: { xs: '10px', sm: '20px' },
            textAlign: 'center',
          }}
        >
          {+ID_SITE_CONST !== 3 ? (
            <>
              <Typography sx={sxStyle.bookingDetailText}>
                <Typography
                  component="span"
                  id="PuntoDeVentaMiReserva"
                  sx={{ fontWeight: 600 }}
                >
                  Punto de venta
                </Typography>
              </Typography>

              <Typography sx={sxStyle.bookingDetailText}>
                Nombre: {bookingDetails?.entity.name}
              </Typography>
              <Typography sx={sxStyle.bookingDetailText}>
                Dirección:&nbsp;{getHref(bookingDetails)}
              </Typography>
              <Typography sx={sxStyle.bookingDetailText}>
                Email: {bookingDetails?.entity.email}
              </Typography>
              <Typography sx={sxStyle.bookingDetailText}>
                Teléfono: {bookingDetails?.entity.phone}
              </Typography>
            </>
          ) : null}
        </Grid>
      )}
    </>
  );
};

export default EntityInfo;
